<template>
  <div class="container">
    <!-- 标题 -->
    <div style="text-align: center">
      <span style="background-color: rgb(56, 68, 118);
        display: block;
        height: 3px;
        margin: 0 auto 12px auto;
        width: 60px;
        "></span>
      <h3 class="newTitle" v-show="newVis">新闻中心</h3>
    </div>

    <!-- 新闻详情显示 -->
    <!-- <transition name="news-details-slide"> -->
      <!-- <div v-if="Details"> -->
      <div class="news-details" v-show="showDetails" id="showNews" name="showNews">

        <div class="centered-content" style="height: 300px">
          <div style="display: flex;
                padding: 10px 0;
                font-family: 'HelveticaNeue';
                font-size: 54px;
                font-weight: bold;
                height: 64px;
                color: #8B8989;
                ">
            <div>0</div>
      
            <div style="overflow: hidden;">
              <div class="changePosition">
                <!-- :class="{ 'slide-up-down': animateTitle }" -->
                <div 
                  v-for="(item, index) in files"
                  
                  style="overflow: hidden;height: 64px;"
                  >
                      {{index+1}}
                </div>
              </div>
              
            </div>
            <div>/</div>
          </div>
          <div 
              style="
              display: flex;
              justify-content: space-between;
              align-items: initial;
             
              overflow: hidden;
              /* transform: translateX(-100px); */
            ">
            <div class="changePositionX" style="display: flex;">
              <div
                v-for="(item, index) in files"
                :key="index"
                style="padding: 20px;cursor: pointer;"
                @click="handleWeixin(item.text)" 
                >
                
                <div class="text-container" >
                  <h3 :class="{ 'slide-in': animateTitle }">{{ item.title }}</h3>
                  <span class="animated" :class="{ 'slide-in': animateText }" v-html="item.abstracts"></span>
                  <!-- <div class="release-time" :class="{ 'slide-in': animateTime }">
                    {{ item.releaseTime }}
                  </div> -->
                </div>
              </div>
            </div>
              
          </div>
         
          

          <!-- navigate -->
          <!-- 切换标签 -->
          <div class="action">
            <div class="img-all" >
              <div @click="changeItemClick(-1)" class="img-container imgHover">
                <img
                  src="../assets/services_arrow_lt.svg"
                />
              </div>
              <div @click="changeItemClick(1)" class="img-container imgHover">
                <img
                  src="../assets/services_arrow_rt.svg"
                />
              </div>
              <div class="img-container" @click="closeDetails">
                <img style="width: 30px;" src="../assets/services_x.svg" />
              </div>
            </div>
          </div>
        </div>
      <!-- </div> -->
    </div>
    <!-- </transition> -->

    <!-- 新闻中心显示 -->
    <transition name="news-list-slide">
      <div class="centered-block" @click="toggleDetails">
        <el-row>
          <el-col
            :span="8"
            v-for="(item, index) in files.slice(0, 6)"
            style="padding-bottom: 20px"
          >
            <a href="#news" class="div-row" @click="newId(item, index)" style="position: relative;" :style="{ backgroundImage: 'url(' + item.picLink + ')' }">
                <div class="itemTitle"  style=""><span>{{ item.title }}</span></div>
            </a>
          </el-col>
        </el-row>
        <!-- 更多新闻 -->
        <div class="container">
          <!-- ... -->
          <a class="more-link" href="/more" target="_blank"> 更多 </a>
            <span style="background-color: rgb(56, 68, 118);
          display: block;
          height: 3px;
          margin: 5px auto 12px auto;
          width: 60px;
          "></span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { Row } from "element-ui";
import $ from "jquery";
import {getSixNews} from '../utils/api.js'
// import Swiper from 'swiper'; // 注意引入的是Swiper
// import 'swiper/css/swiper.min.css' // 注意这里的引入

export default {
  name: "News",
  data() {
    return {
      swiper: '',
      animateId: false, // 控制id动画
      animateTitle: false, // 控制标题动画
      animateText: false, // 控制文本动画
      animateTime: false, // 控制时间动画
      showDetails: false, // 初始新闻详情为隐藏
      Details:false,
      newVis:true,
      selectedItem: [],
      currentIndex: 0,
      selectedItemIndex: 0,
      oldSelectedIndex: 0,
      detailsHeight: '0px', // 初始高度为0
      files: [],
      isShowNumber:false,
      translateNum: 0 ,
      
    };
  },
  created(){
    this.load()
  },
  watch: {
    selectedItemIndex(newVal, oldVal) {
      this.oldSelectedIndex = oldVal;
      // console.log(this.oldSelectedIndex,"old")
      this.selectedItemIndex = newVal;
      // console.log(this.selectedItemIndex,"new")

      //动画效果
      if (this.selectedItemIndex == this.oldSelectedIndex) {
        return;
      } else {
        this.changeItemNum(this.selectedItemIndex);
      }
      // console.log(oldVal)
      return this.files[this.selectedItemIndex];
    },
  },
  mounted(){
    this.$nextTick(() => {
      this.getNum()
    })
    
  },
  updated(){

  },
  methods: {
    handleWeixin(url){
      window.open(url, '_blank')
    },
    getNum() {
      // this.swiper = new Swiper('.swiper-container', {
      //   // paginationClickable : true,
      //   // direction : 'vertical',
      //   // initialSlide :1,
      //   // loop: true,
      
      // });
      
    },
    load(){
      getSixNews().then(res =>{
        // console.log(res)
        if(res.code === 200){
          this.files = res.data
        }
      })
    },
    toggleDetails() {
      // 切换详情的显示状态
      // this.showDetails = true;
      // 使用jQuery实现推拉效果
      this.showDetails = true;
				$("#showNews").slideDown();
        this.isShowNumber = true
      
    },
    //点击箭头
    changeItemClick(direction) {

      // 计算下一个轮播页的索引
      if(direction == 1){
        //向上
        this.currentIndex++;
      }else{
        this.currentIndex--;
      }


      // debugger
      // 切换新闻内容
      if (this.currentIndex < 0) {
        this.currentIndex = this.files.length - 1;
      } else if (this.currentIndex >= this.files.length) {
        this.currentIndex = 0;
      }
      // this.currentIndex = this.currentIndex + direction;
      // if (this.currentIndex <= 0) {
      //   this.currentIndex = 5;
      //   // $('.changePosition').css({"transform": "translateY("+ 5*64 +"px)"});
      // } else if (this.currentIndex >= this.files.length) {
      //   // console.log(this.currentIndex)
      //   this.currentIndex = 0;
      //   // $('.changePosition').css({"transform": "translateY("+  +"px)"});
      // }

       // 计算 translateY 的偏移量
        const translateY = -this.currentIndex * 64;
         // 计算 translateX 的偏移量
        const translateX = -this.currentIndex * 690;

      // 设置 transform 和触发动画
      $('.changePosition').css({ transform: `translateY(${translateY}px)` });
      $('.changePositionX').css({ transform: `translateX(${translateX}px)` });
      
      // this.animate()
      // this.isShowNumber = false
      // $('#itemId').slideDown()
      // setTimeout(() => {
      //   this.isShowNumber = true
      //   $('#itemId').slideUp()
      // }, 200);
    },
    //点击新闻
    changeItemNum(direction){
      // debugger
      this.currentIndex =  direction;
      this.animate()
    },
    //动画
    animate() {
      // 设置动画
      this.animateId = true;
      this.animateTitle = true;
      this.animateText = true;
      this.animateTime = true;
      setTimeout(() => {
        this.animateId = false;
        this.animateTitle = false;
        this.animateText = false;
        this.animateTime = false;
      }, 1000); // 根据你的动画时间来调整
    },
    newId(item, index) {
      
    
      // this.selectedItem = item;

      //获取当前点击的索引新闻详情
      this.selectedItemIndex = index;
      // console.log(this.selectedItemIndex)

       // 计算 translateY 的偏移量
       const translateY = -this.selectedItemIndex * 64;
      // 计算 translateX 的偏移量
       const translateX = -this.selectedItemIndex * 690;

      // 设置 transform 和触发动画
      $('.changePosition').css({ transform: `translateY(${translateY}px)` });
      $('.changePositionX').css({ transform: `translateX(${translateX}px)` });

      // console.log(item)
      this.currentIndex = index;
      // console.log(this.currentIndex)
    },
    closeDetails() {
      $("#showNews").slideUp();
      // $("#item-id").slideToggle()
    },
  },
};
</script>

<style>
.newTitle {
  color: #ccc;
  padding: 0px 30px 30px;
  font-size: 30px;
  font-weight: bold;
}
.newContent {
  color: #7f7f7f;
  letter-spacing: 2px;
  line-height: 25px;
  text-align: center;
  padding: 20px;
  width: 500px;
  margin: 0 auto; /* Center align the div */
}
.container {
  text-align: center;
}
 .centered-block {
  width: 50%;
  display: inline-block;
  padding: 20px;
  margin: 0 auto;
}

ol,
ul {
  list-style: none;
}
li {
  border: 1 solid #ccc;
}

.div-row {
  text-decoration: none;
  cursor: pointer;
  float: left;
  position: relative;
  width: 95%; 
  padding-top: 71.5%; 
  background-color: #232323;
  border: 1px solid #282828;
  background-size: contain; 
  background-position: center; 
  background-repeat: no-repeat;
  overflow: hidden; 
  -webkit-backface-visibility: hidden;
  -webkit-transition: all 0.2s ease-in;
  -moz-transition: all 0.2s ease-in;
  -ms-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;
}

/* 移除内边距，因为现在高度是通过padding-top来控制的 */
.div-row:hover {
  -webkit-transition: all 0.2s ease-in;
  -moz-transition: all 0.2s ease-in;
  -ms-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;
}

.expanded {
  margin-top: 200px; /* 控制向下移动效果 */
}

/* 更多新闻 */
.more-link {
  cursor: pointer;
  text-decoration: underline;
  color: #ccc;
  display: block;
  margin-top: 10px;
  text-decoration: none;
}
.more-link:hover{
  color: #fff;
}

.centered-container {
  display: flex;
  justify-content: center;
  align-items: center;
  /* 添加其他样式 */
}

.news-details {
  background-color: rgb(28,28,28);
  border-top: 1px solid rgb(35,35,35);
  border-bottom: 1px solid rgb(35,35,35);
}

/* html文字显示 */
.right2 p {
    width: auto !important;
    text-align: justify;
}

.centered-content {
  display: flex;
  width: 885px;
  margin: 0 auto;
  margin-top: 20px ;
  margin-bottom: 30px;
  /* display: flex;
  justify-content: center;
  align-items: center; */
  /* 添加其他样式 */
}

.image-container {
  color: #ccc;

  font-family: "HelveticaNeue", "Helvetica Neue", "HelveticaNeueRoman",
    "HelveticaNeue-Roman", "Helvetica Neue Roman", "TeXGyreHerosRegular",
    "Helvetica", "Tahoma", "Geneva", "Arial", sans-serif;
  font-size: 54px;
  font-weight: bold;
  height: 54px;
  line-height: 44px;
  padding-right: 3px;
  width: 110px;
}

.text-container {
  width: 650px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* align-items: center; */
}


.text-container h3 {
  font-size: 38px;
  font-weight: bold;
  height: 54px;
  line-height: 44px;
  font-family: "HelveticaNeue", "Helvetica Neue", "HelveticaNeueRoman",
    "HelveticaNeue-Roman", "Helvetica Neue Roman", "TeXGyreHerosRegular",
    "Helvetica", "Tahoma", "Geneva", "Arial", sans-serif;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.text-container span {
  font-size: 14px;
  color: #ccc;
  text-indent: 2em;
  text-align: justify;
  height: 220px;
  overflow: auto;
  /* overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis; */
}
.text-container span::-webkit-scrollbar {
  width: 8px; /* 设置滚动条宽度 */
}

.text-container span::-webkit-scrollbar-thumb {
  background-color: #888; /* 设置滚动条滑块的背景颜色 */
  border-radius: 4px; /* 设置滚动条滑块的圆角 */
}

.text-container span::-webkit-scrollbar-thumb:hover {
  background-color: #555; /* 鼠标悬停时的滚动条滑块颜色 */
}
.text-container span::-webkit-scrollbar-track {
  background-color: #f2f2f2; /* 设置滚动条轨道的背景颜色 */
  border-radius: 4px; /* 设置滚动条轨道的圆角 */
  margin-left: 10px; /* 设置滚动条轨道右边距，调整滚动条和内容之间的宽度 */
}

.release-time {
  margin-top: auto; /* 将内容推到底部 */
  text-align: right; /* 右对齐 */
}

.action {
  display: flex;
  align-items: initial;
  margin: 20px 0;
}

.action div {
  cursor: pointer !important;
  height: 80px;
  margin-bottom: 5px;
  position: relative;
  width: 100px;
}

.action img {
  width: 20px;
  height: 30px;
  margin-left: 36px;
  position: absolute;
  top: 27%;
}
.img-container {
  display: flex;
  /* align-items: center; */
  margin: 0 10px; /* 调整图片之间的间距 */
}

.imgHover {
  background-color: #232323;
  border: 1px solid #282828;
}

/* 样式设置 */

/* .news-item-fade-enter-active,
.news-item-fade-leave-active {
  transition: opacity 0.5s;
}

.news-item-fade-enter, .news-item-fade-leave-to  {
  opacity: 0;
} */

.slide-up-down {
  /* 定义上下切换的CSS动画效果 */
  animation: slideUpDown 0.2s ease-in-out forwards;
}
@keyframes slideUpDown {
  from {
    transform: translateY(-50%);
  }
  to {
    transform: translateY(0);
  }
}


@keyframes slideIn {
  from {
    transform: translateX(-50px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.animated {
  animation-duration: 0.5s; /* 调整动画时间 */
      padding: 0px 10px 0px 0px;
}

.slide-in {
  animation: slideIn 0.3s ease;
}

/* 新闻详情推拉动画 */ 
/* .news-details-slide-enter-active,
.news-details-slide-leave-active {
  transition: max-height 0.5s ease-in-out, opacity 0.5s ease-in-out;
}

.news-details-slide-enter,
.news-details-slide-leave-to {
  max-height: 0;
  opacity: 0;
} */

.imgHover:hover{
  background-color: rgb(56, 68, 118) !important;
}

/* 新闻中心推拉动画 */
.news-list-slide-enter-active,
.news-list-slide-leave-active {
  transition: max-height 0.5s ease-in-out, opacity 0.5s ease-in-out;
  /* transition: height 400ms ease-out 0s, margin-top 400ms ease-out 0s, margin-bottom 400ms ease-out 0s, 
  padding-top 400ms ease-out 0s,padding-bottom 400ms ease-out 0s; */
}

.news-list-slide-enter, .news-list-slide-leave-to /* .fade-leave-active in <2.1.8 */ {
  max-height: 0;
  opacity: 0;
}
.changePosition{
  transition: all 0.5s;
}
.changePositionX{
  transition: all 0.5s;
}
.changePositionX:hover{
  color: #fff;
}
.text-container span:hover{
  color: #fff !important;
}
.itemTitle{
  color: #F0F3F4;
  position: absolute;
  width: calc(100% - 40px);
  height: calc(100% - 40px);
  background-color: rgba(0, 0, 0, 0.7);
  left: 0;
  top: 0;
  padding: 20px; 
  display: flex;
  align-items: center;
  justify-content: center;
}
.itemTitle:hover{
  background-color: rgba(151, 154, 154, 0.5);
  color: #232323;
}
</style>
